import Vue from 'vue';
import Vuex from 'vuex';

import aclConfig from './aclConfig';
import errors from './errors';
import snackbar from './snackbar';
import passAccount from './passAccount';
import navigation from './navigation';
import user from './user';
import history from './history';
import administration from './administration';

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		navigation,
		administration,
		aclConfig,
		history,
		errors,
		user,
		passAccount,
		snackbar
	}
});
